import { apiSlice } from "../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDatasource: builder.query({
      query: () => ({
        url: "/connectpg/getdataSources",
        method: "GET",
      }),
    }),
    deleteDataSource: builder.mutation({
      query: (ID) => ({
        url: "/connectpg/delete",
        method: "DELETE",
        body: { connectionId: ID },
      }),
      invalidatesTags: (result, error, { ID }) => [
        { type: "DataSource", id: ID },
      ],
    }),
    getSingleDS: builder.mutation({
      query: (dataSourceId) => {
        console.log(dataSourceId);
        return {
          url: "connectpg/getDataSourceDetails",
          method: "POST",
          body: { dataSourceId },
        };
      },
    }),
    editDataSource: builder.mutation({
      query: (payload) => {
        console.log(payload);
        return {
          url: "/connectpg/editDataSource",
          method: "PATCH",
          body: payload,
        };
      },
      invalidatesTags: (result, error, { id }) => [{ type: "DataSource", id }],
    }),
    refetchColumnsDetails: builder.mutation({
      query: (dataSourceID) => {
        console.log(dataSourceID);
        return {
          url: "connectpg/refetchColumnDetails",
          method: "POST",
          body: { dataSourceID },
        };
      },
    }),
    createMeeting: builder.mutation({
      query: (object) => ({
        url: "/sqlTable/save",
        method: "POST",
        body: object,
      }),
      invalidatesTags: ['Meetings'],
    }),
    
    editMeeting: builder.mutation({
      query: (object) => ({
        url: "/sqlTable/Edit",
        method: "POST",
        body: object,
      }),
      invalidatesTags: ['Meetings'],
    }),
    
    getMeetings: builder.mutation({
      query: (object) => ({
        url: "/sqlTable/getMeetings",
        method: "POST",
        body: object,
      }),
      providesTags: ['Meetings'],
    }),
    
  }),
});

// Export hooks for usage in functional components
export const {
  useGetDatasourceQuery,
  useEditDataSourceMutation,
  useDeleteDataSourceMutation,
  useGetSingleDSMutation,
  useRefetchColumnsDetailsMutation,
  useCreateMeetingMutation,
  useEditMeetingMutation,
  useGetMeetingsMutation,
} = sqlApiSlice;
